/**
 * SparkEffect Styles
 * Styles for the spark particle effect
 */

import { StyleSheet } from 'react-native';
import { theme } from '../../../theme';
import { makeBoxShadow } from '../../../src/shared/helpers/shadowStyles.helper';

export const sparkEffectStyles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  spark: {
    position: 'absolute',
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.accent,
    ...makeBoxShadow({
      shadowColor: theme.accent,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.8,
      shadowRadius: 4,
    }),
    elevation: 4,
  },
});

